import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import Title from "./Title";
import Form from "./Form";

const Login = () => {
	return (
		<>
			<Header />
			<Title />
			<Form />
			<Footer />
		</>
	);
};
export default Login;
